import { Migration } from '@mydocma/core/src/lib/migration';
import { IDBPDatabase } from 'idb';
import { MmProjectDbCollections } from '../../mm-project-db-schema';

export const V19: Migration = {

  up(database: IDBPDatabase<unknown>) {
    database.createObjectStore(MmProjectDbCollections.integrations_files,  { keyPath: 'Id' });
  },

};
